import { mutatorAction } from "satcheljs";
import { getAddAccountCampaignStore } from "../store/AddAccountCampaignStore";
import type { AddAccountCampaignViewState } from "../store/schema/addAccountCampaignState";

export const setAddAccountCampaignViewStateMutator: (state: AddAccountCampaignViewState) => void = mutatorAction("setAddAccountCampaignViewStateMutator", (state: AddAccountCampaignViewState): void => {
    getAddAccountCampaignStore().viewState = state;
});
